"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _MobileNav = require("./MobileNav.styles");

var _DesktopNav = require("../DesktopNav/DesktopNav.style");

var _MobileNavHeader = _interopRequireDefault(require("./MobileNavHeader"));

var _MobileNavFooter = _interopRequireDefault(require("./MobileNavFooter"));

var MobileNav = function MobileNav(_ref) {
  var actions = _ref.actions,
      account = _ref.account,
      homeLink = _ref.homeLink,
      logoImage = _ref.logoImage,
      primaryLinks = _ref.primaryLinks,
      secondaryLinks = _ref.secondaryLinks,
      accessibility = _ref.accessibility;

  var _ref2 = (0, _react.useState)('Menu'),
      _ref3 = _slicedToArray(_ref2, 2),
      activeMenuTitle = _ref3[0],
      setActiveMenuTitle = _ref3[1];

  var _ref4 = (0, _react.useState)([]),
      _ref5 = _slicedToArray(_ref4, 2),
      activeNav = _ref5[0],
      setActiveNav = _ref5[1];

  var _ref6 = (0, _react.useState)(false),
      _ref7 = _slicedToArray(_ref6, 2),
      showMenu = _ref7[0],
      setShowMenu = _ref7[1];

  var openMenu = function openMenu() {
    setShowMenu(true);
  };

  var goBackMenu = function goBackMenu() {
    if (activeMenuTitle === 'Menu') {
      setShowMenu(false);
    } else {
      setActiveMenuTitle('Menu');
    }
  };

  var navigateTo = function navigateTo(items, label) {
    setActiveMenuTitle(label);
    setActiveNav(items);
  };

  var headerProps = {
    account: account,
    activeMenuTitle: activeMenuTitle,
    goBackMenu: goBackMenu
  };
  var footerProps = {
    actions: actions,
    secondaryLinks: secondaryLinks
  };

  var renderHomeMenu = function renderHomeMenu() {
    var _account$avatar, _account$avatar2, _account$avatar2$imag, _account$avatar2$imag2;

    return /*#__PURE__*/_react.default.createElement(_MobileNav.MenuMain, {
      role: "navigation",
      "aria-label": accessibility === null || accessibility === void 0 ? void 0 : accessibility.primaryMenuLabel
    }, /*#__PURE__*/_react.default.createElement(_MobileNav.UnstyledList, null, primaryLinks.map(function (item) {
      // Add More from link to the second level navigation
      var items = (0, _toConsumableArray2.default)(item === null || item === void 0 ? void 0 : item.navItems);

      if (item === null || item === void 0 ? void 0 : item.url) {
        items.push(_objectSpread(_objectSpread({}, item), {}, {
          label: "More about ".concat(item === null || item === void 0 ? void 0 : item.label)
        }));
      }

      return /*#__PURE__*/_react.default.createElement("li", {
        key: item.label
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.MobileMenuItem, {
        onClick: function onClick() {
          return navigateTo(items, item.label);
        }
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.MenuLabel, null, item.label), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "ChevronRight"
      })));
    }), account && /*#__PURE__*/_react.default.createElement("li", {
      key: "profile-menu-item"
    }, /*#__PURE__*/_react.default.createElement(_MobileNav.MobileMenuItem, {
      onClick: function onClick() {
        return navigateTo(account.menu, 'Profile');
      }
    }, /*#__PURE__*/_react.default.createElement(_DesktopNav.MenuWrapper, null, /*#__PURE__*/_react.default.createElement(_MobileNav.ProfileIcon, {
      size: "small",
      name: account === null || account === void 0 ? void 0 : (_account$avatar = account.avatar) === null || _account$avatar === void 0 ? void 0 : _account$avatar.name,
      image: {
        src: account === null || account === void 0 ? void 0 : (_account$avatar2 = account.avatar) === null || _account$avatar2 === void 0 ? void 0 : (_account$avatar2$imag = _account$avatar2.image) === null || _account$avatar2$imag === void 0 ? void 0 : (_account$avatar2$imag2 = _account$avatar2$imag.fluid) === null || _account$avatar2$imag2 === void 0 ? void 0 : _account$avatar2$imag2.src
      }
    }), /*#__PURE__*/_react.default.createElement(_MobileNav.MenuLabel, null, "Profile")), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "ChevronRight"
    })))));
  };

  var renderSecondaryMenu = function renderSecondaryMenu() {
    return /*#__PURE__*/_react.default.createElement(_MobileNav.MenuMain, {
      role: "navigation",
      "aria-label": accessibility === null || accessibility === void 0 ? void 0 : accessibility.secondaryMenuLabel
    }, activeNav.map(function (item) {
      var handleClick = function handleClick(e) {
        if (typeof item.onClick === 'function') {
          item.onClick(e);
        }

        setShowMenu(false);
      };

      return /*#__PURE__*/_react.default.createElement(_MobileNav.MenuLink, {
        to: item.url,
        key: item.label,
        onClick: handleClick
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.MobileMenuItem, {
        hasDecription: !!item.description
      }, /*#__PURE__*/_react.default.createElement(_MobileNav.MenuLabel, null, item.label), /*#__PURE__*/_react.default.createElement(_DesktopNav.MenuWrapper, null, /*#__PURE__*/_react.default.createElement(_MobileNav.MenuDescription, null, item.description), item.url !== '/logout' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "ChevronRight"
      }))));
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Logo.default, {
    homeLink: homeLink,
    logoImage: logoImage
  }), /*#__PURE__*/_react.default.createElement(_DesktopNav.MenuWrapper, {
    onClick: openMenu
  }, /*#__PURE__*/_react.default.createElement(_MobileNav.MenuTitle, null, "Menu"), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "Menu"
  })), /*#__PURE__*/_react.default.createElement(_MobileNav.MenuBurgerWrapper, {
    showMenu: showMenu
  }, /*#__PURE__*/_react.default.createElement(_MobileNavHeader.default, headerProps), activeMenuTitle === 'Menu' ? renderHomeMenu() : renderSecondaryMenu(), !account && activeMenuTitle === 'Menu' && /*#__PURE__*/_react.default.createElement(_MobileNavFooter.default, footerProps)));
};

MobileNav.propTypes = {
  /** Object defining account area, avatar property is used to control display of the avatar circle, either with image or name, menu is the array of items supplied to the dropdown menu */
  account: _propTypes.default.shape({
    avatar: _propTypes.default.shape({
      image: _propTypes.default.shape({
        /** Fluid image object */
        fluid: _propTypes.default.shape({
          base64: _propTypes.default.string.isRequired,
          aspectRatio: _propTypes.default.number.isRequired,
          src: _propTypes.default.string.isRequired,
          srcSet: _propTypes.default.string.isRequired,
          srcSetWebp: _propTypes.default.string.isRequired,
          sizes: _propTypes.default.string.isRequired
        }),

        /** File src of image object in case we dont have a fluid obj */
        src: _propTypes.default.string
      }),
      name: _propTypes.default.string
    }),
    menu: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      onClick: _propTypes.default.func,
      url: _propTypes.default.string
    }))
  }),

  /** Array of objects defining Primary Nav Menu. onClick callback is optional but useful for implementing things like tracking */
  primaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      description: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })),

  /** Array of objects defining Secondary Nav Menu (Actions Menu). onClick callback is optional but useful for implementing things like tracking */
  secondaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      description: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })),

  /** Array of objects defining Call to Actions (Buttons) */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string
  })),

  /** Home address of the page, this typically be '/' */
  homeLink: _propTypes.default.string,

  /** Image object allowing to replace the theme logo with a custom one */
  logoImage: _propTypes.default.shape({
    /** Fluid image object */
    fluid: _propTypes.default.shape({
      base64: _propTypes.default.string.isRequired,
      aspectRatio: _propTypes.default.number.isRequired,
      src: _propTypes.default.string.isRequired,
      srcSet: _propTypes.default.string.isRequired,
      srcSetWebp: _propTypes.default.string.isRequired,
      sizes: _propTypes.default.string.isRequired
    }),

    /** File src of image object in case we dont have a fluid obj */
    src: _propTypes.default.string
  }),
  accessibility: _propTypes.default.shape({
    /** Accessibility label for the primary menu */
    primaryMenuLabel: _propTypes.default.string,

    /** Accessibility label for the secondary menu */
    secondaryMenuLabel: _propTypes.default.string,

    /** Accessibility label for the user menu */
    userMenuLabel: _propTypes.default.string
  })
};
MobileNav.defaultProps = {
  account: null,
  actions: [],
  primaryLinks: [],
  secondaryLinks: [],
  homeLink: '/',
  logoImage: null,
  accessibility: null
};
var _default = MobileNav;
exports.default = _default;